import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, CheckCircle, Users, BarChart, Award } from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';
export function SponsorshipPage() {
  // Using the provided Formspree ID
  const [state, handleSubmit] = useForm('mzzjzkpj');
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    sponsorshipLevel: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const sponsorshipLevels = [{
    title: 'Platinum',
    price: '$10,000',
    benefits: ['Premier logo placement on all event materials', 'Speaking opportunity', '1 complimentary event pass', 'Access to attendee list with contact information', 'Featured in post-event recap materials', 'Opportunity to provide branded gift items']
  }, {
    title: 'Gold',
    price: '$5,000',
    benefits: ['Prominent logo placement on event materials', '1 complimentary event pass', 'Access to attendee list (name and company only)', 'Mentioned in post-event recap materials']
  }, {
    title: 'Silver',
    price: '$2,500',
    benefits: ['Logo on event materials', 'Company mentioned during event']
  }];
  return <div className="w-full min-h-screen bg-[#FFF8DC]" data-id="element-297">
      <Header data-id="element-298" />
      <main data-id="element-299">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-[#2F1B10]" data-id="element-300">
          <div className="absolute inset-0 z-0 opacity-30" data-id="element-301">
            <img src="https://images.unsplash.com/photo-1544025162-d76694265947?w=2070&q=80" alt="Austin BBQ" className="w-full h-full object-cover" data-id="element-302" />
          </div>
          <div className="container relative z-10 mx-auto px-4 md:px-6 text-white" data-id="element-303">
            <div className="max-w-3xl" data-id="element-304">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 font-serif" style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-305">
                Sponsorship Opportunities
              </h1>
              <p className="text-xl md:text-2xl font-light mb-8 text-[#FFF8DC]" data-id="element-306">
                Connect your brand with top ecommerce CFOs at the Commerce CFO
                Roundtable - Austin
              </p>
              <a href="#sponsorship-packages" className="inline-flex items-center gap-2 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold px-6 py-3 rounded-md transition-colors shadow-lg" data-id="element-307">
                View Sponsorship Packages
                <ChevronRight size={18} data-id="element-308" />
              </a>
            </div>
          </div>
        </section>
        {/* Benefits Section */}
        <section className="py-20 bg-[#FFF8DC]" data-id="element-309">
          <div className="container mx-auto px-4 md:px-6" data-id="element-310">
            <div className="text-center mb-16" data-id="element-311">
              <h2 className="text-3xl md:text-4xl font-bold text-[#2F1B10] font-serif" style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-312">
                Why Sponsor the Commerce CFO Roundtable?
              </h2>
              <div className="mt-4 w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-313"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto" data-id="element-314">
              <div className="text-center bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#D2691E]" data-id="element-315">
                <div className="flex justify-center mb-4" data-id="element-316">
                  <div className="bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-317">
                    <Users className="text-[#D2691E]" size={32} data-id="element-318" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#8B4513] font-serif" data-id="element-319">
                  Exclusive Access
                </h3>
                <p className="text-[#556B2F]" data-id="element-320">
                  Connect directly with 50+ ecommerce CFOs and finance leaders
                  in an intimate Austin setting
                </p>
              </div>
              <div className="text-center bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#D2691E]" data-id="element-321">
                <div className="flex justify-center mb-4" data-id="element-322">
                  <div className="bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-323">
                    <BarChart className="text-[#D2691E]" size={32} data-id="element-324" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#8B4513] font-serif" data-id="element-325">
                  Brand Visibility
                </h3>
                <p className="text-[#556B2F]" data-id="element-326">
                  Showcase your brand to decision-makers during workshops and
                  the Franklin BBQ dinner
                </p>
              </div>
              <div className="text-center bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#D2691E]" data-id="element-327">
                <div className="flex justify-center mb-4" data-id="element-328">
                  <div className="bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-329">
                    <Award className="text-[#D2691E]" size={32} data-id="element-330" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#8B4513] font-serif" data-id="element-331">
                  Thought Leadership
                </h3>
                <p className="text-[#556B2F]" data-id="element-332">
                  Position your company as a leader in financial innovation and
                  ecommerce strategy
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Sponsorship Packages */}
        <section id="sponsorship-packages" className="py-20 bg-white" data-id="element-333">
          <div className="container mx-auto px-4 md:px-6" data-id="element-334">
            <div className="text-center mb-16" data-id="element-335">
              <h2 className="text-3xl md:text-4xl font-bold text-[#2F1B10] font-serif" style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-336">
                Sponsorship Packages
              </h2>
              <div className="mt-4 w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-337"></div>
              <p className="mt-6 text-lg text-[#556B2F] max-w-2xl mx-auto" data-id="element-338">
                Choose the package that best aligns with your marketing
                objectives and budget
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-339">
              {sponsorshipLevels.map((level, index) => <div key={index} className="bg-white rounded-lg shadow-xl overflow-hidden border border-[#D2691E]" data-id="element-340">
                  <div className="bg-[#2F1B10] text-white p-6 text-center" data-id="element-341">
                    <h3 className="text-2xl font-bold font-serif" data-id="element-342">
                      {level.title}
                    </h3>
                    <p className="text-3xl font-bold mt-2 text-[#F4A460]" data-id="element-343">
                      {level.price}
                    </p>
                  </div>
                  <div className="p-6 bg-[#FFF8DC]" data-id="element-344">
                    <ul className="space-y-3" data-id="element-345">
                      {level.benefits.map((benefit, i) => <li key={i} className="flex items-start" data-id="element-346">
                          <CheckCircle className="text-[#D2691E] mr-2 shrink-0 mt-1" size={16} data-id="element-347" />
                          <span className="text-[#556B2F]" data-id="element-348">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Contact Form */}
        <section id="contact" className="py-20 bg-[#FFF8DC]" data-id="element-349">
          <div className="container mx-auto px-4 md:px-6" data-id="element-350">
            <div className="max-w-4xl mx-auto" data-id="element-351">
              <div className="text-center mb-16" data-id="element-352">
                <h2 className="text-3xl md:text-4xl font-bold text-[#2F1B10] font-serif" style={{
                fontFamily: 'Rockwell, "Courier New", serif'
              }} data-id="element-353">
                  Become a Sponsor
                </h2>
                <div className="mt-4 w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-354"></div>
                <p className="mt-6 text-lg text-[#556B2F] max-w-2xl mx-auto" data-id="element-355">
                  Interested in sponsoring the Commerce CFO Roundtable? Fill out
                  the form below and our team will contact you with more
                  information.
                </p>
              </div>
              {state.succeeded ? <div className="bg-white rounded-lg shadow-xl p-8 text-center border border-[#D2691E]" data-id="element-356">
                  <div className="mb-6 text-[#556B2F]" data-id="element-357">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-358">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-359" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-[#2F1B10]" data-id="element-360">
                    Thank You!
                  </h3>
                  <p className="text-lg mb-6 text-[#556B2F]" data-id="element-361">
                    Your sponsorship inquiry has been received. We will send you
                    event information within 24 hours.
                  </p>
                </div> : <div className="bg-white rounded-lg shadow-xl p-8 border border-[#D2691E]" data-id="element-362">
                  <form onSubmit={handleSubmit} data-id="element-363">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-364">
                      <div data-id="element-365">
                        <label htmlFor="name" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-366">
                          Full Name*
                        </label>
                        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-367" />
                        <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-368" />
                      </div>
                      <div data-id="element-369">
                        <label htmlFor="company" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-370">
                          Company*
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-371" />
                        <ValidationError prefix="Company" field="company" errors={state.errors} data-id="element-372" />
                      </div>
                      <div data-id="element-373">
                        <label htmlFor="email" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-374">
                          Email Address*
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-375" />
                        <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-376" />
                      </div>
                      <div data-id="element-377">
                        <label htmlFor="phone" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-378">
                          Phone Number*
                        </label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-379" />
                        <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-380" />
                      </div>
                      <div className="md:col-span-2" data-id="element-381">
                        <label htmlFor="sponsorshipLevel" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-382">
                          Interested Sponsorship Level
                        </label>
                        <select id="sponsorshipLevel" name="sponsorshipLevel" value={formData.sponsorshipLevel} onChange={handleChange} className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-383">
                          <option value="" data-id="element-384">Select a sponsorship level</option>
                          <option value="Platinum" data-id="element-385">Platinum ($10,000)</option>
                          <option value="Gold" data-id="element-386">Gold ($5,000)</option>
                          <option value="Silver" data-id="element-387">Silver ($2,500)</option>
                          <option value="Custom" data-id="element-388">Custom Package</option>
                        </select>
                        <ValidationError prefix="Sponsorship Level" field="sponsorshipLevel" errors={state.errors} data-id="element-389" />
                      </div>
                      <div className="md:col-span-2" data-id="element-390">
                        <label htmlFor="message" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-391">
                          Additional Information
                        </label>
                        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="Please share any specific interests or questions you have about sponsorship opportunities." data-id="element-392"></textarea>
                        <ValidationError prefix="Message" field="message" errors={state.errors} data-id="element-393" />
                      </div>
                    </div>
                    <div className="mt-8" data-id="element-394">
                      <button type="submit" disabled={state.submitting} className="w-full bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold py-4 rounded-lg transition-all shadow-lg hover:shadow-[#D2691E]/30 disabled:opacity-70" data-id="element-395">
                        {state.submitting ? 'Submitting...' : 'Submit Inquiry'}
                      </button>
                    </div>
                    <ValidationError errors={state.errors} data-id="element-396" />
                  </form>
                </div>}
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-397" />
    </div>;
}